import React from 'react';

// eslint-disable-next-line no-unused-vars
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-cycle
import { NumberBox } from 'ui/atoms';
import theme from 'ui/theme';
import MainFont from 'ui/typography/mainFont';

import { AlertWrapper } from './style';

const AlertContainer = ({ alertCounter = [] }) => (
  <AlertWrapper>
    {alertCounter.length > 0
      ? alertCounter.map(alert =>
          Object.keys(alert).map((al, index) => (
            <NumberBox
              key={index}
              bigNumber={alert[al] || '-'}
              align="flex-start"
              icon="icon-danger"
              iconColor={theme().colors.semantic.primary}
              iconSize="23"
              circleSize="40px"
              numberSize={32}
              top={55}
            >
              <MainFont type="numberTitle" configuration={{ fontSize: 14 }}>
                {al}
              </MainFont>
            </NumberBox>
          ))
        )
      : null}
  </AlertWrapper>
);

AlertContainer.propTypes = {
  alertCounter: PropTypes.array
};

export default AlertContainer;
